import React, { useState, useEffect } from "react";
import { SquarePen } from "lucide-react";
import styled from "styled-components";
import BehalfModal from "./behalfModal";
import useFetcher from "../../hooks/useFetcher";
import { fetchPiAsignable } from "../../services/ticketingServices";
import { CustomLabel } from "../../ui/labels";

const Button = styled.button`
  font-size: 16px;
  font-family: "Nunito", sans-serif;
  background-color: #f7f7f7;
  border: none;
  color: #062541;
  cursor: pointer;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 8px;
  padding: 10px;

  &:hover {
    opacity: 0.8;
  }
  &:focus {
    outline: none;
    box-shadow: none;
  }
`;

const CreateTicketInBehalf = ({ createInBehalf, formik, setisOnBehalf, isOnBehalf }) => {
  const [piAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [createInBehalfModal, setCreateInBehalfModal] = useState(false);
  const [createInBehalfName, setCreateInBehalfName] = useState("");
  const [onBehalfErrors, setonBehalfErrors] = useState(false);

  useEffect(() => {
    if (formik.values.nombre && formik.values.apellido) {
      setCreateInBehalfName(`${formik.values.nombre} ${formik.values.apellido}`);
    } else if (formik.values.piAsignado) {
      setCreateInBehalfName(
        `${
          piAsignable.find((pi) => {
            return pi.itemId === formik.values.piAsignado;
          }).nombreApellido
        }`
      );
    } else {
      setCreateInBehalfName(createInBehalf);
    }
    if (formik.errors) {
      if (
        (formik.errors.categoria && formik.touched.categoria) ||
        (formik.errors.nombre && formik.touched.nombre) ||
        (formik.errors.apellido && formik.touched.apellido) ||
        (formik.errors.dniCreador && formik.touched.dniCreador)
      ) {
        setonBehalfErrors(true);
      } else {
        setonBehalfErrors(false);
      }
    }
    if (formik.values.dniCreador === "") {
      formik.setFieldValue("dniCreador", undefined);
    }
    if (formik.values.telefonoCreador === "") {
      formik.setFieldValue("telefonoCreador", undefined);
    }
    if (formik.values.nombre === "") {
      formik.setFieldValue("nombre", undefined);
    }
    if (formik.values.apellido === "") {
      formik.setFieldValue("apellido", undefined);
    }
    if (formik.values.email === "") {
      formik.setFieldValue("email", undefined);
    }
  }, [formik]);

  return (
    <>
      {createInBehalfModal ? (
        <BehalfModal toggle={() => setCreateInBehalfModal(!createInBehalfModal)} formik={formik} setisOnBehalf={setisOnBehalf} isOnBehalf={isOnBehalf} />
      ) : null}
      <div className="mb-3 mt-3">
        <CustomLabel htmlFor="createdInBehalf" fontSize="18px" fontWeight="800">
          Creado para
          <div className="d-flex justify-content-between">
            <Button
              type="button"
              onClick={() => {
                setCreateInBehalfModal(!createInBehalfModal);
                setisOnBehalf(true);
              }}
            >
              <p className="mb-0 text-uppercase">{createInBehalfName}</p>
              <SquarePen size={16} />
            </Button>
          </div>
        </CustomLabel>
        {onBehalfErrors && <div className="input-feedback">Tiene datos por completar.</div>}
      </div>
    </>
  );
};

export default CreateTicketInBehalf;
